import React from 'react';
import styles from './PFSAgencyTransform.module.css';
import ContentContainer from '../ContentContainer/ContentContainer';
import agencyTransformLogo from './AgencyTransform_logo.png';
import { NavLink, useLocation } from 'react-router-dom';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { PartnersIndexBreadcrumb } from '../PFSPartnersIndex/PFSPartnersIndex';

const PFSAgencyTransform = () => {
  const { pathname } = useLocation();

  useBreadcrumb([
    PartnersIndexBreadcrumb,
    {
      label: 'Agency Transformation',
      url: pathname,
    },
  ]);

  return (
    <div className={styles.PfsAgencyTransform} data-testid='PfsAgencyTransform'>
      <ContentContainer>
        <img className={styles.logo} src={agencyTransformLogo} alt='Agency Transformation' />
        <h1>Agency Transformation Joins PFS Global as a Partner!</h1>
        <div className={styles.content}>
          <p>
            We are pleased to announce that Agency Transformation has become a
            partner of PFS Global. Agency Transformation was established in
            2017 and is based in Thousand Oaks, CA.
          </p>
          <p>
            Our consulting services provide HawkSoft CMS agency owners
            with guidance that is critical to their success by
            offering solutions to maximize profitability, effectiveness and efficiency.
            Our consultants are experienced insurance professionals who have deep
            knowledge of the business of insurance.
          </p>
          <p>
            This collaboration allows us to integrate Agency Transformation's
            expertise into our offerings, ensuring that we deliver enhanced
            value and efficiency to you, our esteemed clients.
          </p>
          <p>
            For more information about Agency Transformation, please visit{' '}
            <a href='https://www.agencytransform.com' target='_blank' rel='noopener noreferrer'>www.agencytransform.com</a>, or reach out
            directly via email at{' '}
            <a href='mailto:info@agencytransform.com'>info@agencytransform.com</a>.
          </p>
          <p>
            We are excited about the opportunities this partnership presents and
            are available to address any inquiries or feedback you may have.
          </p>
          <NavLink to={'/who-we-trust'} id={styles.homeBtn}>
            Back to Who We Trust
          </NavLink>
        </div>
      </ContentContainer>
    </div>
  );
};

export default PFSAgencyTransform;

